module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "date-tool"
  }, [_c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.time))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f9489b2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/date-tool/index.vue
// module id = 238
// module chunks = 0